import {Box, Stack, styled} from '@mui/material';

const ContentContainer = styled(Stack)`
	padding: 16px;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 16px 24px;
	}
`;

const StyledStack = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const StyledGrid = styled(Box)`
	display: grid;
	grid-template-columns: 1fr;
	gap: 12px;

	${({theme}) => theme.breakpoints.up('sm')} {
		grid-template-columns: 1fr 1fr;
	}
`;

const StyledAddressContainer = styled(Stack)`
	flex-direction: column;
	gap: 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
		align-items: center;
		gap: 16px;
	}
`;

export {ContentContainer, StyledStack, StyledGrid, StyledAddressContainer};
